import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import { useCart } from '../../context/CartContext';
import { useUI } from '../../context/UIContext';
import { IconHome, IconGrid, IconCart, IconSearch, IconUser } from '../common/Icons';

// Fixed bottom bar on mobile: Home / Shop / Cart / Search / Account (hides while scrolling down)
export default function MobileStickyBar() {
  const { settings } = useSettings();
  const { count, setOpen } = useCart();
  const { setSearchOpen } = useUI();
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let last = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      setHidden(y > last && y > 200);
      last = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (settings.shop?.mobileStickyBar === false) return null;
  const icon = 'w-[22px] h-[22px]';
  return (
    <div className={`footer-mobile__common md:hidden flex justify-between bg-white ${hidden ? 'scroll-up' : ''}`}>
      <div className="footer__common-item"><NavLink to="/" aria-label="Home"><IconHome className={icon} /></NavLink></div>
      <div className="footer__common-item"><NavLink to="/collections/all" aria-label="Shop"><IconGrid className={icon} /></NavLink></div>
      <div className="footer__common-item">
        <button type="button" className="relative py-2 sf-cart-icon px-2 whitespace-nowrap cursor-pointer cart-icon" onClick={() => setOpen(true)} aria-label="Cart">
          <span className="sf__tooltip-item block sf__tooltip-bottom sf__tooltip-style-2"><IconCart className={icon} /></span>
          <span className={`sf-cart-count font-medium ${count === 0 ? 'cart-empty' : ''}`}>{count}</span>
        </button>
      </div>
      <div className="footer__common-item"><button type="button" className="sf__search-footer-common" onClick={() => setSearchOpen(true)} aria-label="Search"><IconSearch className={icon} /></button></div>
      <div className="footer__common-item"><NavLink to="/account" aria-label="Account"><IconUser className={icon} /></NavLink></div>
    </div>
  );
}
